export const environments = [
  "development",
  "local",
  "preview",
  "production",
] as const;
export type Environment = (typeof environments)[number];

const prodLikeEnvironments: Environment[] = ["preview", "production"];

export function isProdLike(env: string): boolean {
  return prodLikeEnvironments.includes(env as Environment);
}
